/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonEdit.title', 'defaultMessage': 'Editing Application Addon'}
});

interface ChannelAddonEditProps {
    intl: IntlShape;
    user: User;
}

class ChannelAddonEdit extends React.Component<ChannelAddonEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channelAddons';

    constructor(props) {
        super(props);
    }

    render() {
        let channel = this.props.user.organisation.channel;
        let data = channel.channelAddon;
        let type = types[this.typeName];

        let fields = {
            'name': {
            },
        };

        if (data.addonDef && data.addonDef.allowConnectedChannelSelection) {
            fields['connectedChannel'] = {
                values: this.props.user.organisation.channels.edges.map(({node}) => node),
                display: (item) => {
                    if (item['name']) {
                        return item['name'] + " / " + item['channelDef']['name'];
                    } else {
                        return item['channelDef']['name'];
                    }
                },
            };
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: type, data: data},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]}  title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={fields}
                    data={data}
                    fatQuery={Relay.QL `fragment on UpdateChannelAddonPayload @relay(pattern: true) {
                        updatedNode {
                            id,
                            name,
                            connectedChannel_id,
                            connectedChannel {
                                id,
                                realId,
                            }
                        },
                    }`}
                    metadata={type}
                    mutation={Relay.QL `mutation { updateChannelAddon }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation.channel}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonEdit), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.channelAddon;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        channelAddonId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
               organisation(id: $organisationId) {
                   id,
                   realId,
                   name,
                   channels(first: 1000, deleted: false) {
                       edges {
                           node {
                               id,
                               realId,
                               name,
                               channelDef {
                                   id,
                                   realId,
                                   name,
                                   type
                               }
                           }
                       }
                   }
                   channel(id: $channelId) {
                       id,
                       name,
                       organisation_id,
                       channelDef {
                           id,
                           name
                       },
                       channelAddon(id: $channelAddonId) {
                           id,
                           organisation_id,
                           channel_id,
                           name,
                           addonDef {
                               id,
                               allowConnectedChannelSelection,
                           },
                           connectedChannel_id,
                           connectedChannel {
                               id,
                               realId,
                               name,
                               channelDef {
                                   id,
                                   name,
                                   type
                               }
                           },
                       },
                   }
               }
            }
        `,
    },
});
